<template>
  <footer v-show="isVisible">
    <div class="top">
      <div class="container">
        <div class="row">
          <div class="row-inc">
            <div class="center">
              <div class="row">
                <div class="col items" v-if="!isMobile">
                  <h1>Spor</h1>
                  <ul>
                    <li><router-link :to="{ name: 'Sportsbook'}"> Spor Bahisleri</router-link></li>
                    <li><router-link :to="{ name: 'Live'}"> Canlı Bahis</router-link></li>
                    <li><router-link :to="{ name: 'Virtual'}"> Sanal Bahis</router-link></li>
                  </ul>
                </div>
                <div class="col items" v-if="!isMobile">
                  <h1>Casino</h1>
                  <ul>
                    <li><router-link :to="{ name: 'Slot'}"> Casino</router-link></li>
                    <li><router-link :to="{ name: 'Casino'}"> Canlı Casino</router-link></li>
                  </ul>
                </div>
                <div class="col items" v-if="!isMobile">
                  <h1>Sanal</h1>
                  <ul>
                    <li><router-link :to="{ name: 'Sportsbook'}"> Mobil Oyunlar</router-link></li>
                    <li><router-link :to="{ name: 'Live'}"> E-Sporlar</router-link></li>
                  </ul>
                </div>
                <div class="col items" v-if="!isMobile">
                  <h1>Masa Oyunları</h1>
                  <ul>
                    <li><router-link :to="{ name: 'Betongames'}"> Poker</router-link></li>
                    <li><router-link :to="{ name: 'Bingo'}"> Tombala</router-link></li>
                    <li><router-link :to="{ name: 'Bingo'}"> TV Games</router-link></li>
                  </ul>
                </div>
                <div class="col items">
                  <h1>Yardım</h1>
                  <ul>
                    <li v-for="(item, key) in pages" :key="key"><router-link :to="{ name: 'Page', params:{slug: item.url} }">{{ item.title }}</router-link></li>
                  </ul>
                </div>
                <div class="col items">
                  <h1>İletişim</h1>
                  <ul>
                    <li><a href="javascript:;">destek@{{ _.lowerCase($store.getters['getClientMeta'].name).split(' ').join('') }}.com</a></li>
                    <li><a href="javascript:;">marketing@{{ _.lowerCase($store.getters['getClientMeta'].name).split(' ').join('') }}.com</a></li>
                  </ul>
                </div>
                <div class="col items" v-if="!isMobile">
                  <SocialMedia v-if="!isMobile"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="row-inc">
          <div class="images">
          </div>
          <SocialMedia style="text-align: center; display: block; margin-bottom: 10px;" class="align-center"  v-if="isMobile"/>
          <div class="licence">
            <div class="logo">
              <router-link to="/" class="logo">
                <img width="200" src="@/assets/images/logo.png">
              </router-link>
            </div>
            <div class="licence-footer">
              <div class="licence-button">
                <a target="_blank" href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJaXMyYXk5dFdFOUtibEpMTVhKcWJVMWpiV0ZYVTFFOVBTSXNJblpoYkhWbElqb2lTRUpIU0d4WGEzQlRNMmg0V2xJemJ6VkJhblpEVVQwOUlpd2liV0ZqSWpvaVpUVm1ObVE1WTJSaE5tRXhPREkwTXpVeFpqYzNPRGszTkROaU16WTRNV1E0TTJZd00yWmpaR1ptTXpVNVlqUTFaVEF5TVRVNU1UVmxaVFkxTmpreE1DSXNJblJoWnlJNklpSjk=">
                  <img src="https://seal.cgcb.info/8b089e55-4795-425a-6bf6-fdb75eba6900" width="88" height="50">
                </a>
              </div>
            </div>
          </div>
          <img src="@/assets/images/common/providers.png" width="100%">
          <p class="copyright">© 2022 {{ $store.getters['getClientMeta'].name }} Tüm hakları saklıdır.</p>
          <div style="text-align: center;">
            {{ $store.getters['getClientMeta'].name }}  website is operated by Joker Marketing B.V and currently in the GCB application process
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<style lang="scss">
  .licence-footer{
    display: flex;
  }
  #app.mobile .licence-footer{
    flex-direction: column;
    align-content: center;
    justify-content: center;
    .licence-button{
      text-align: center;
    }
  }
</style>
<script>
	import Logo from './Header/Logo'
	import SocialMedia from './SocialMedia'
  export default{
    data(){
      return{
        languageDropdown : false,
      }
    },
    computed:{
      egt_show(){
        if(this.locale == 'TR' && this.user && this.user.balance > 0){
          return true
        }else{
          return false
        }
      },
      providers(){
        return this.$store.getters['special/footerProviders'];
      },
      social(){
        return this.$store.getters.getClientContent;
      },
      pages() {
        return this.$store.getters.getClientPages;
      },
      lang(){
        return this.$store.getters.getLanguages;
      },
      isVisible(){
        if(this.$route.name == 'Homepage' && this.isMobile || !this.isMobile){
          return true;
        }else{
          return false;
        }
      }
    },
    methods:{
      upTop(){
        window.scrollTo(0,0);
      }
    },
		components:{
      Logo,
			SocialMedia
		}
  }
</script>